/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statistics_Day_2Inputs */

const he_statistics_day_2 = /** @type {(inputs: Statistics_Day_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שלישי`)
};

const en_statistics_day_2 = /** @type {(inputs: Statistics_Day_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuesday`)
};

/**
* | output |
* | --- |
* | "Tuesday" |
*
* @param {Statistics_Day_2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const statistics_day_2 = /** @type {((inputs?: Statistics_Day_2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statistics_Day_2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_statistics_day_2(inputs)
	return en_statistics_day_2(inputs)
});